/**
 * screenShare slice: 화면 공유 상태 관리
 * wehago-conference의 redux/modules/screenShare 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ScreenShareState {
  // 내 화면 공유 중 여부
  isSharing: boolean;
  // 현재 화면 공유 중인 참여자 ID (타인 포함)
  sharingUserId: string | null;
  // 데스크톱 오디오 믹싱 중 여부 (탭 오디오 + 마이크)
  isAudioMixed: boolean;
}

const initialState: ScreenShareState = {
  isSharing: false,
  sharingUserId: null,
  isAudioMixed: false,
};

const screenShareSlice = createSlice({
  name: 'screenShare',
  initialState,
  reducers: {
    setSharing(state, action: PayloadAction<boolean>) {
      state.isSharing = action.payload;
      if (!action.payload) {
        state.isAudioMixed = false;
      }
    },

    setSharingUserId(state, action: PayloadAction<string | null>) {
      state.sharingUserId = action.payload;
    },

    setAudioMixed(state, action: PayloadAction<boolean>) {
      state.isAudioMixed = action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const screenShareActions = screenShareSlice.actions;
export default screenShareSlice.reducer;
